import React from 'react';
import classNames from 'classnames';
import { Trash2, Plus } from 'lucide-react';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';
import ConfirmationModal from '../../components/ConfirmationModal';

export default function Card({
  placeholder = '',
  name,
  className,
  editMode = false,
  addHandler,
  updateHandler,
  background,
  removeHandler,
  locales: { common },
  maxCount,
  card: { icon, title, subtitle, list },
  wBlur = true,
  titleColor,
  textColor,
  circleColor,
  lineColor,
  borderCardColor,
  textStyle,
  buttonStyle,
  buttonVariant = 'outline',
}) {
  return (
    <div
      className={classNames('bmc-page-keycard-wrapper', className, {
        'bmc-page-keycard--edit-mode': editMode,
      })}
    >
      <div
        className="bmc-page-keycard"
        style={{ backgroundColor: background, borderColor: borderCardColor }}
      >
        {title && (
          <div className="bmc-page-keycard-header">
            <div className="bmc-page-keycard-header-icon">
              <img src={icon} alt="" />
            </div>
            <div
              className="bmc-page-keycard-header-title custom-font-title"
              style={{ color: titleColor }}
            >
              {title}
            </div>
          </div>
        )}

        {subtitle && (
          <div
            className="bmc-page-keycard-title custom-font-title mb-4"
            style={{ color: titleColor }}
          >
            {subtitle}
          </div>
        )}

        <ul className="bmc-page-keycard-list">
          {list.map((item) => (
            <li
              key={item.id}
              className="bmc-page-keycard-list-item flex flex-row items-center"
            >
              {editMode ? (
                <>
                  <div
                    className="circle"
                    style={{ backgroundColor: circleColor }}
                  />
                  <Textarea
                    placeholder={placeholder}
                    value={item.description || ''}
                    delay={700}
                    className={`bmc-form-textarea ${textStyle} custom-font-body flex items-center`}
                    onChange={(e) =>
                      updateHandler({
                        id: item.id,
                        name: 'description',
                        value: e.target.value,
                      })
                    }
                  />
                  {list.length > 1 && (
                    <ConfirmationModal
                      className="ml-3 hover:bg-muted-lighter/60 text-muted-darker"
                      body={common.deleteConfirmation}
                      confirmText="Delete"
                      onConfirm={() => removeHandler({ id: item.id })}
                      buttonAriaLabel="Delete"
                    >
                      <Trash2 className="w-6 min-w-6 h-auto" />
                    </ConfirmationModal>
                  )}
                </>
              ) : (
                <div
                  className="resorses-text custom-font-body"
                  style={{ color: textColor }}
                >
                  <div
                    className="circle"
                    style={{ backgroundColor: circleColor }}
                  />
                  <div
                    className="line"
                    style={{ backgroundColor: lineColor }}
                  />
                  {item.description}
                </div>
              )}
            </li>
          ))}
        </ul>

        {editMode && list.length < maxCount && (
          <Button
            variant={buttonVariant}
            onClick={addHandler}
            className={`w-full bg-transparent ${buttonStyle}`}
          >
            <Plus className="w-7 h-auto" />
            {`${common.create} ${name}`}
          </Button>
        )}
      </div>
      {wBlur && <div className="bmc-page-keycard-blur" />}
    </div>
  );
}
